var React = require('react');

function SliderPrevArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 27.1524L10 20.4857L14 13.8191","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

SliderPrevArrow.defaultProps = {"width":"24","height":"41","viewBox":"0 0 24 41","fill":"none"};

module.exports = SliderPrevArrow;

SliderPrevArrow.default = SliderPrevArrow;
